import Dropzone from 'react-dropzone';
import styled from 'styled-components';
import { useState } from 'react';
import { Alert } from '@mui/material';

const WrapperAlert = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 50px;
  z-index: 3000;
  animation: showAlert 0.5s;
  margin-top: 15px;
  display: flex;
  justify-content: center;
  @keyframes showAlert {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 1;
    }
  }
`;
const DivAlert = styled.div`
  min-width: 320px;
  width: fit-content;
  .MuiPaper-root-MuiAlert-root {
    border-radius: 16px;
  }
`;
const UploadVideo = ({
  children,
  callBackFile,
  sizeFile,
  textAlert,
  closeAlert,
}) => {
  const [showAlert, setShowAlert] = useState(false);

  const onDrop = (acceptedFiles, name) => {
    const reader = new FileReader();
    // const maxSize = sizeFile !== sizeFile ? sizeFile : 1000000;
    //  4194304
    const fileUpload = acceptedFiles.map((file) =>
      Object.assign(file, {
        fileData: URL.createObjectURL(file),
      })
    );

    if (acceptedFiles.length === 0) {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2500);
    } else {
      acceptedFiles.map((file) => {
        reader.onload = (e) => {
          callBackFile(fileUpload[0], e.target.result);
        };
        reader.readAsDataURL(file);
        return file;
      });
    }
  };

  return (
    <>
      <Dropzone
        onDrop={(acceptedFiles) => onDrop(acceptedFiles)}
        accept={['.mp4']}
        maxSize={20 * 1024 * 1024}
      >
        {({ getRootProps, getInputProps }) => (
          <section>
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              <div>{children}</div>
            </div>
          </section>
        )}
      </Dropzone>
      {showAlert && (
        <WrapperAlert>
          <DivAlert>
            <Alert className='MuiPaper-root-MuiAlert-root' severity={'warning'}>
              {'The file size is larger than 20 MB.'}
            </Alert>
          </DivAlert>
        </WrapperAlert>
      )}
    </>
  );
};

export default UploadVideo;
